<app-progress-bar [assumptionsForm]="assumptionsForm"></app-progress-bar>
<div class="assumptions-form">
  <form [formGroup]="assumptionsForm" (ngSubmit)="submitForm()">
    <h2>Ajustar los supuestos</h2>

    <!-- Inflation   -->
    <h3>Inflación</h3>
    <div class="mat-form-field-container">
      <mat-form-field appearance="outline">
        <input matInput formControlName="inflation" required>
        <span matSuffix>%</span>
        <mat-error *ngIf="assumptionsForm.get('inflation')?.invalid">
          {{getErrorMessage('inflation')}}
        </mat-error>
      </mat-form-field>
    </div>
    <!--    <input class="input" formControlName="inflation" required>-->

    <!-- Discount Rate   -->
    <div>
      <h3>Tasa descuento</h3>
      <p class="description">Coste de capital que determina el valor actual de un pago futuro</p>
    </div>
    <mat-form-field appearance="outline">
      <input matInput formControlName="discountRate" required>
      <span matSuffix>%</span>
      <mat-error *ngIf="assumptionsForm.get('discountRate')?.invalid">
        {{getErrorMessage('discountRate')}}
      </mat-error>
    </mat-form-field>

    <!-- hUpgradeTare   -->
    <div>
      <h3>Tasa de mejora hidrógeno</h3>
      <p class="descrption">Porcentaje de mejora anual en la tecnología que impacta en los costos</p>
    </div>
    <mat-form-field appearance="outline">
      <input matInput formControlName="hUpgradeRate" required>
      <span matSuffix>%</span>
      <mat-error *ngIf="assumptionsForm.get('hUpgradeRate')?.invalid">
        {{getErrorMessage('hUpgradeRate')}}
      </mat-error>
    </mat-form-field>

    <!-- d, e, h truck lifespans   -->
    <h3 class="double-column">Vidas útiles de los camiones</h3>
    <!--    <table>-->
    <!--      <tr>-->
    <!--        <th>Diesel</th>-->
    <!--        <td><input formControlName="dLifespan" required></td>-->
    <!--      </tr>-->
    <!--      <tr>-->
    <!--        <th>Eléctrico</th>-->
    <!--        <td><input formControlName="eLifespan" required></td>-->
    <!--      </tr>-->
    <!--      <tr>-->
    <!--        <th>Hidrógeno</th>-->
    <!--        <td><input formControlName="hLifespan" required></td>-->
    <!--      </tr>-->
    <!--    </table>-->
    <h3>Diesel</h3>
    <mat-form-field appearance="outline">
      <input matInput formControlName="dLifespan" required>
      <span matSuffix>años</span>
      <mat-error *ngIf="assumptionsForm.get('dLifespan')?.invalid">
        {{getErrorMessage('dLifespan')}}
      </mat-error>
    </mat-form-field>
    <h3>Eléctrico</h3>
    <mat-form-field appearance="outline">
      <input matInput formControlName="eLifespan" required>
      <span matSuffix>años</span>
      <mat-error *ngIf="assumptionsForm.get('eLifespan')?.invalid">
        {{getErrorMessage('eLifespan')}}
      </mat-error>
    </mat-form-field>
    <h3>Hidrógeno</h3>
    <mat-form-field appearance="outline">
      <input matInput formControlName="hLifespan" required>
      <span matSuffix>años</span>
      <mat-error *ngIf="assumptionsForm.get('hLifespan')?.invalid">
        {{getErrorMessage('hLifespan')}}
      </mat-error>
    </mat-form-field>

    <!-- COMAP discount   -->
    <h3>Descuento COMAP</h3>
    <div class="vertically-aligned">
      <div class="vertical-alignment-container">
        <input class="checkbox" formControlName="investment" type="checkbox" id="investment" name="investment"
               (change)="changeInvestment()" checked>
        <label for="investment">Inversión = Vehículo</label>
      </div>
    </div>
    <h3 [ngClass]="{'transparent': assumptionsForm.get('investment')?.value}">Inversión mayor</h3>
    <mat-form-field appearance="outline">
      <input matInput formControlName="majorInvestment" required>
      <span matSuffix [ngClass]="{'transparent': assumptionsForm.get('investment')?.value}">USD</span>
      <mat-error *ngIf="assumptionsForm.get('majorInvestment')?.invalid">
        {{getErrorMessage('majorInvestment')}}
      </mat-error>
    </mat-form-field>


    <!-- Infrastructure   -->
    <h3>Costo infraestructura hidrógeno</h3>
    <mat-form-field appearance="outline">
      <input matInput formControlName="hInfrastructureCost" required>
      <span matSuffix>USD/kg</span>
      <mat-error *ngIf="assumptionsForm.get('hInfrastructureCost')?.invalid">
        {{getErrorMessage('hInfrastructureCost')}}
      </mat-error>
    </mat-form-field>

    <!-- Send form button   -->
    <div>
      <button class="send-button" mat-raised-button color="primary">Enviar</button>
    </div>
  </form>
</div>
